import api from './api';

const API_URL = '';

const buildReportParams = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key]) params.append(key, filters[key]);
  });
  return params.toString();
};

export const workReportService = {
  // Aggregierte Stunden-Auswertung (pro Techniker + KC)
  getSummary: async (filters = {}) => {
    const response = await api.get(`/work-reports/summary?${buildReportParams(filters)}`);
    return response.data;
  },

  // Detaillierter CSV-Export (Download)
  exportSummaryCsv: async (filters = {}) => {
    const response = await api.get(`/work-reports/export?${buildReportParams(filters)}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Stundenauswertung.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  },

  // Get all work reports for a ticket
  getWorkReportsByTicket: async (ticketId) => {
    try {
      const response = await api.get(`/tickets/${ticketId}/work-reports`);
      return response.data;
    } catch (error) {
      console.error('Error fetching work reports:', error);
      throw error;
    }
  },

  // Create a new work report
  createWorkReport: async (ticketId, workReportData) => {
    try {
      const response = await api.post(`/tickets/${ticketId}/work-reports`, workReportData);
      return response.data;
    } catch (error) {
      console.error('Error creating work report:', error);
      throw error;
    }
  },

  // Update a work report
  updateWorkReport: async (id, workReportData) => {
    try {
      const response = await api.put(`/work-reports/${id}`, workReportData);
      return response.data;
    } catch (error) {
      console.error('Error updating work report:', error);
      throw error;
    }
  },

  // Delete a work report
  deleteWorkReport: async (id) => {
    try {
      await api.delete(`/work-reports/${id}`);
    } catch (error) {
      console.error('Error deleting work report:', error);
      throw error;
    }
  },

  // Export work reports as PDF
  exportPDF: async (ticketId) => {
    try {
      const response = await api.get(`/tickets/${ticketId}/work-reports/pdf`, {
        responseType: 'blob'
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Extract filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = `Arbeitsbericht_${ticketId}.pdf`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Error exporting PDF:', error);
      throw error;
    }
  },

  // Export work reports for a specific date as PDF
  exportDailyPDF: async (ticketId, date) => {
    try {
      const response = await api.get(`/tickets/${ticketId}/work-reports/pdf/daily/${date}`, {
        responseType: 'blob'
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Extract filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = `Arbeitsbericht_${ticketId}_${date}.pdf`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Error exporting daily PDF:', error);
      throw error;
    }
  }
};